import React from 'react';
import Section from './Section';
import './About.css';

const About = () => {
  const skillGroups = [
    {
      title: 'Languages & Development',
      skills: ['Python', 'Java', 'C++', 'C#', 'JavaScript', 'Bash', 'React', 'HTML', 'CSS', '.NET Development']
    },
    {
      title: 'Tools',
      skills: ['Pytest', 'Postgres', 'Docker', 'Selenium', 'Jenkins', 'GitHub Actions', 'Git', 'SVN', 'Linux', 'WiX', 'Confluence API']
    },
    {
      title: 'Networking & Security',
      skills: ['PKI', 'X.509 Certificates', 'TPM-backed Authentication', 'gRPC', 'OpenConfig']
    },
    {
      title: 'Professional',
      skills: ['Technical Documentation', 'Strategic Communication', 'Team Collaboration', 'Problem Solving']
    }
  ];

  const credentials = [
    {
      code: 'EDU',
      title: 'University of Waterloo',
      description: 'BASc in Computer Engineering, Candidate'
    },
    {
      code: 'AWD',
      title: 'Scholarships',
      description: "President's Scholarship recipient + Alexander Rutherford Scholarship recipient"
    },
    {
      code: 'RCM',
      title: 'Royal Conservatory of Music',
      description: 'Grade 10 Piano (Honours) and Grade 8 Theory (Honours with Distinction), 2014-2023'
    },
    {
      code: 'SKI',
      title: 'FIS Alpine Ski Racing',
      description: 'Team Panorama, 2013-2024'
    }
  ];

  return (
    <Section 
      id="about" 
      title="About"
      subtitle="Education, skills, and technical focus."
      className="about-section"
    >
      <div className="about-content">
        <div className="about-text">
          <p className="about-bio">
            I am a Computer Engineering candidate at the University of Waterloo.
            I build automation for testing, reporting, and release workflows.
          </p>
          <p className="about-bio">
            My experience spans embedded optical software, PKI and X.509 validation,
            CI/CD, and Python data pipelines.
          </p>
          <div className="credential-grid">
            {credentials.map((credential) => (
              <article key={credential.code} className="credential-card">
                <span>{credential.code}</span>
                <h3>{credential.title}</h3>
                <p>{credential.description}</p>
              </article>
            ))}
          </div>
        </div>
        <div className="about-interests">
          <h3>Skills</h3>
          <div className="skill-groups">
            {skillGroups.map((group) => (
              <div key={group.title} className="skill-group">
                <h4>{group.title}</h4>
                <div className="skills-grid">
                  {group.skills.map((skill) => (
                    <span key={skill} className="skill-tag">{skill}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Section>
  );
};

export default About;
